// ---------------------------------------------------------------------------
// Ganchos do harness de replay determinístico (tests/replay). Só existem com "?dbg=1&replay=1".
// O app registra aqui funções de LEITURA do estado de navegação e os MESMOS caminhos de código dos gestos
// (arrasto, troca de modo/ativo); o harness chama isso quadro a quadro com o relógio parado.
// Sem a flag, `replay` é null e nada é registrado (constante de módulo: zero custo).
// ---------------------------------------------------------------------------
import { DBG_ENABLED } from './dbgFlag';

export const REPLAY_ENABLED: boolean = (() => {
  try { return DBG_ENABLED && new URLSearchParams(window.location.search).get('replay') === '1'; } catch { return false; }
})();

export const replay: Record<string, any> | null = REPLAY_ENABLED ? ((window as any).__replay = {}) : null;
